import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { useReduxDispatch } from '../../app/store';
import { fetchEvChargerDetails, selectEvChargerData } from '../ev-charger/dashboard/evChargerSlice';

/** Loads charger details (incl. rated `output`) once per session for screens reachable without the dashboard. */
export function useEvChargerDetails() {
  const dispatch = useReduxDispatch();
  const { hasFetchedEvChargerDetails, siteDeviceId } = useSelector(selectEvChargerData);

  useEffect(() => {
    if (!hasFetchedEvChargerDetails && siteDeviceId) {
      dispatch(fetchEvChargerDetails(siteDeviceId));
    }
  }, [hasFetchedEvChargerDetails, siteDeviceId, dispatch]);
}
